// Arquivo gerado dinamicamente via scripts/setup-env.js a partir do .env.local
// NÃO commitar com credenciais reais!
export const environment = {
    production: true,
    version: '2.1.27',
    supabaseUrl: 'https://supabase.filasaude.cloud',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzc0MzIxMjAwLCJleHAiOjE5MzIwODc2MDB9.Ymn_w5gwKY8vJHTnxqeAO4t6xFD4XEMR_vr28EBtBsc'
};
